import { Card, CardContent } from '@mui/material';
import React from 'react';

import { HealthLineChart } from '@components/Charts/Line';
import DeviceDataAttribution from '@components/DeviceDataAttribution';

import { useHealthChart } from '@hooks/useHealthChart';

import { MetricVisual } from '@models/graph';

import { hasDeviceSourcedData } from '@utils/device-brand';

import Table from './Table';
import Header from './VisualHeader';

export default function DataVisualization() {
  const { code, completeData, data, view } = useHealthChart();
  const isTableView = view === MetricVisual.Table;

  return (
    <Card>
      <CardContent
        sx={({ palette }) => ({
          backgroundColor: palette.grey['100'],
        })}
      >
        <Header />
      </CardContent>

      {/* Padding is spelled out rather than leaning on MUI's :last-child
      rule, since the attribution below is now the last child. */}
      <CardContent
        sx={{
          pb: isTableView ? 0 : 3,
          pt: isTableView ? 0 : 2,
          px: 0,
        }}
      >
        {isTableView ? (
          <Table />
        ) : (
          <HealthLineChart
            code={code}
            data={data}
            options={{ showNormalRange: true }}
          />
        )}
      </CardContent>

      {hasDeviceSourcedData(completeData) ? (
        // Gated on the readings themselves, not the category: Body mixes scale
        // readings with manually entered weights, so a category test claims
        // connected devices supplied a chart they had no part in.
        //
        // Body text rather than the footnote treatment used by the averaging
        // disclaimer above it, which is the placement the brand guidelines
        // reject.
        <CardContent sx={{ pt: 0 }}>
          <DeviceDataAttribution
            color="text.secondary"
            surface={isTableView ? 'table' : 'chart'}
          />
        </CardContent>
      ) : null}
    </Card>
  );
}
